"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateNurseLicenseDto = instanceOfCreateNurseLicenseDto;
exports.CreateNurseLicenseDtoFromJSON = CreateNurseLicenseDtoFromJSON;
exports.CreateNurseLicenseDtoFromJSONTyped = CreateNurseLicenseDtoFromJSONTyped;
exports.CreateNurseLicenseDtoToJSON = CreateNurseLicenseDtoToJSON;
exports.CreateNurseLicenseDtoToJSONTyped = CreateNurseLicenseDtoToJSONTyped;
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the CreateNurseLicenseDto interface.
 */
function instanceOfCreateNurseLicenseDto(value) {
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    return true;
}
function CreateNurseLicenseDtoFromJSON(json) {
    return CreateNurseLicenseDtoFromJSONTyped(json, false);
}
function CreateNurseLicenseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenseNumber': json['licenseNumber'],
        'jurisdiction': json['jurisdiction'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'skipFormatting': json['skipFormatting'] == null ? undefined : json['skipFormatting'],
    };
}
function CreateNurseLicenseDtoToJSON(json) {
    return CreateNurseLicenseDtoToJSONTyped(json, false);
}
function CreateNurseLicenseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenseNumber': value['licenseNumber'],
        'jurisdiction': value['jurisdiction'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'skipFormatting': value['skipFormatting'],
    };
}
//# sourceMappingURL=CreateNurseLicenseDto.js.map